import { FlexBox } from '@ardoq/layout';
import { ControlIcon, IconSize } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';
import { Text } from '@ardoq/typography';
import { DEFAULT_ARDOQ_I18NLOCALE, type I18nLocale, t } from '@ardoq/i18n';

type RedactedFieldDisplayProps = {
  i18nLocale?: I18nLocale;
};

export const getRedactedFieldDisplay = (i18nLocale?: I18nLocale) => (
  <RedactedFieldDisplay i18nLocale={i18nLocale} />
);

export const RedactedFieldDisplay = ({
  i18nLocale = DEFAULT_ARDOQ_I18NLOCALE,
}: RedactedFieldDisplayProps = {}) => {
  const label = t(
    i18nLocale,
    'renderers:confidentialField.noAccess',
    'You do not have access to view this confidential field'
  );
  return (
    <FlexBox
      gap="small"
      align="center"
      role="img"
      aria-label={label}
      data-tooltip-text={label}
    >
      <Text color="textSubtle" variant="text2">
        —
      </Text>
      <ControlIcon iconSize={IconSize.MEDIUM} color={colors.textSubtle} />
    </FlexBox>
  );
};
